import _ from "lodash";
import axios from "axios";
import { MYSELF, CHILD, PET } from "@/constants/CustomerTypes";

const actions = {
    find({ }, appointmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/appointments/${appointmentId}`)
                .then((res) => {
                    resolve(res.data?.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    cancelAppointment({ }, cancelData) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `/appointments/${cancelData.appointment_id}/cancel`,
                    cancelData
                )
                .then((res) => {
                    resolve(res.data?.data?.appointment);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    cancelExam({ }, cancelData) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/exams/${cancelData.exam_id}/cancel`, cancelData)
                .then((res) => {
                    resolve(res.data?.data?.exam);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    reject({ }, params) {
        return new Promise((resolve, reject) => {
            axios
                .post("/appointments/reject", params)
                .then((res) => {
                    resolve(true);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    sendReportEmail({ }, appointmentId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/appointments/${appointmentId}/email-report`)
                .then((res) => {
                    resolve(true);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    changeLocation({ }, changeLocationData) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `/appointments/${changeLocationData.id}/change-location`,
                    changeLocationData
                )
                .then((res) => {
                    resolve(res.data?.data?.appointment);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    updateAppointmentMeta({ }, metasData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/schedule/update-meta", metasData)
                .then((res) => {
                    resolve(res.data?.data?.appointmentMetas);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getAverage({ }, filterDate) {
        return new Promise((resolve, reject) => {
            axios
                .get("/admin/appointments/list/average", {
                    params: { dates: filterDate },
                })
                .then((res) => {
                    resolve(res.data?.data?.average);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getCalendarData({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios
                .get("/appointments/calendar-appointments", {
                    params,
                })
                .then((res) => {
                    resolve(res.data.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getAppointmentData({ commit }, dateRange) {
        return new Promise((resolve, reject) => {
            axios
                .get("/admin/appointments/data", {
                    params: { dates: dateRange },
                })
                .then((res) => {
                    resolve(res.data.datas);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getVideoAccessToken({ }, appointmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/video/appointment/${appointmentId}/patient`)
                .then((res) => {
                    resolve(res.data.token);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    downloadICSFile({ }, appointmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/appointments/${appointmentId}/invite`, {
                    responseType: "blob",
                })
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "invite.ics");
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    downloadEmr({ }, appointmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/medico/record/emr/${appointmentId}`, {
                    responseType: "blob",
                })
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                        "download",
                        `emr-${appointmentId}.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    downloadJsonData({ }, appointmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/appointments/${appointmentId}/json-data`, {
                    responseType: "blob",
                })
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                        "download",
                        `appointment-${appointmentId}.json`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getServiceCategories({ commit }) {
        commit("mutateLoadingGeneral", true);
        return new Promise((resolve, reject) => {
            axios
                .get("/schedule/get-service-categories")
                .then((res) => {
                    commit(
                        "mutateServiceCategories",
                        res.data?.data?.categories
                    );
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingGeneral", false);
                });
        });
    },

    getCitiesByCategory({ commit, state }, payload) {
        const { selectedCategory } = state.appointments[state.currentIndex];
        return new Promise((resolve, reject) => {
            axios
                .get(
                    `/schedule/get-cities-by-category/${payload || selectedCategory.id
                    }`
                )
                .then((res) => {
                    commit("mutateCitiesByCategory", res.data?.data?.cities);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    searchPublicServices({ commit, state }, payload = undefined) {
        const { selectedCategory, serviceKeyword, selectedServiceCities } =
            state.appointments[state.currentIndex];
        commit("mutateLoadingServices", true);
        return new Promise((resolve, reject) => {
            axios
                .post(
                    "/schedule/search-services",
                    payload || {
                        serviceCategoryId: selectedCategory?.id,
                        keyword: serviceKeyword,
                        cities: selectedServiceCities,
                        excludeDeleted: true,
                    }
                )
                .then((res) => {
                    commit("mutatePublicServices", res.data?.data?.services);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingServices", false);
                });
        });
    },

    getCitiesByPublicServiceDescription({ commit, state }, payload) {
        const { publicService } = state.appointments[state.currentIndex];
        return new Promise((resolve, reject) => {
            axios
                .get(
                    `/schedule/get-cities-by-service/${payload || publicService.id
                    }`
                )
                .then((res) => {
                    commit("mutateCitiesByService", res.data?.data?.cities);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    searchLocations({ commit, state }, payload = undefined) {
        const { publicService, locationKeyword, selectedLocationCities } =
            state.appointments[state.currentIndex];
        commit("mutateLoadingLocations", true);
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `/schedule/search-locations/${payload?.serviceId || publicService.id
                    }`,
                    {
                        keyword: payload?.keyword || locationKeyword,
                        cities: payload?.cities || selectedLocationCities,
                        excludeDeleted: true,
                    }
                )
                .then((res) => {
                    commit("mutateLocations", res.data?.data?.locations);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingLocations", false);
                });
        });
    },

    getEmployeesFromLocation({ commit, state }, payload = undefined) {
        const { service, location } = state.appointments[state.currentIndex];
        commit("mutateLoadingEmployees", true);
        return new Promise((resolve, reject) => {
            axios
                .get(
                    `/schedule/location-employees/${payload?.serviceId || service.id
                    }/${payload?.locationId || location.id}`
                )
                .then((res) => {
                    commit("mutateEmployees", res.data?.data?.employees);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingEmployees", false);
                });
        });
    },

    getEmployeeSchedule({ commit, state }, payload) {
        commit("mutateLoadingSchedule", true);
        const { service, location, employee } =
            state.appointments[state.currentIndex];
        return new Promise((resolve, reject) => {
            axios
                .get("/schedule/available-slots", {
                    params: payload || {
                        duration: service.duration,
                        location_id: location.id,
                        employee_id: employee.id,
                    },
                })
                .then((res) => {
                    commit("mutateEmployeeSchedule", res.data.data.datas);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingSchedule", false);
                });
        });
    },

    getBookedTimes({ commit, state }) {
        const { bookingDate, employee, location } =
            state.appointments[state.currentIndex];
        commit("mutateLoadingTimeSlots", true);
        return new Promise((resolve, reject) => {
            axios
                .get("/schedule/get-booked-times", {
                    params: {
                        date: bookingDate,
                        employee_id: employee.id,
                        location_id: location.id,
                    },
                })
                .then((res) => {
                    commit("mutateBookedTimes", res.data?.data?.bookedTimes);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingTimeSlots", false);
                });
        });
    },

    getCustomerChildren({ commit, state }) {
        const { id } = state.appointments[state.currentIndex].customer;
        commit("mutateLoadingChildren", true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/customers/${id}/children/all`)
                .then((res) => {
                    commit("mutateCustomerChildren", res.data?.data?.datas);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingChildren", false);
                });
        });
    },

    getCustomerPets({ commit, state }) {
        const { id } = state.appointments[state.currentIndex].customer;
        commit("mutateLoadingPets", true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/customers/${id}/pet/all`)
                .then((res) => {
                    commit("mutateCustomerPets", res.data?.data?.datas);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingPets", false);
                });
        });
    },

    save({ commit, state }, appointmentId) {
        commit("mutateLoadingGeneral", true);
        const appointments = _.map(state.appointments, (appointment) => ({
            appointment_id: appointmentId,
            public_service_description_id: appointment.publicService.id,
            customer_id: appointment.customer.id,
            child_id: appointment.customer.childId,
            pet_id: appointment.customer.petId,
            service_id: appointment.service.id,
            location_id: appointment.location.id,
            employee_id: appointment.employee.id,
            appointment_date: appointment.schedule.bookingDate,
            start_time: appointment.schedule.startTime,
            end_time: appointment.schedule.endTime,
        }));
        return new Promise((resolve, reject) => {
            axios
                .post(
                    "/customers/schedule_appointment",
                    {
                        issue_id: state.issueId,
                        main_problem: state.mainProblem,
                        appointments
                    }
                )
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("mutateLoadingGeneral", false);
                });
        });
    },

    getAppointment({ dispatch, state, commit }, id) {
        commit("mutateLoadingGeneral", true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/schedule/appointments/${id}`)
                .then((res) => {
                    const { appointment } = res.data?.data;
                    const serviceCategoryId = appointment.service_category_id
                        ? appointment.service_category_id[0]
                        : undefined;
                    Promise.all([
                        dispatch("getServiceCategories"),
                        dispatch("getCitiesByCategory", serviceCategoryId),
                        dispatch(
                            "getCitiesByPublicServiceDescription",
                            appointment.public_service_description_id
                        ),
                        dispatch("searchPublicServices", {
                            serviceCategoryId,
                            keyword: "",
                            cities: [],
                        }),
                        dispatch("searchLocations", {
                            serviceId:
                                appointment.public_service_description_id,
                            keyword: "",
                            cities: [],
                        }),
                        dispatch("getEmployeesFromLocation", {
                            serviceId: appointment.service_id,
                            locationId: appointment.location_id,
                        }),
                    ])
                        .then((response) => {
                            commit(
                                "mutateSelectedCategory",
                                _.find(
                                    state.serviceCategories,
                                    (category) =>
                                        category.id === serviceCategoryId
                                )
                            );
                            commit(
                                "mutateSelectedPublicServiceDescription",
                                _.find(
                                    state.publicServices,
                                    (publicService) =>
                                        publicService.id ===
                                        appointment.public_service_description_id
                                )
                            );
                            commit(
                                "mutateSelectedLocation",
                                _.find(
                                    state.locations,
                                    (location) =>
                                        location.id === appointment.location_id
                                )
                            );
                            commit(
                                "mutateSelectedEmployee",
                                _.find(
                                    state.employees,
                                    (employee) =>
                                        employee.id === appointment.employee_id
                                )
                            );
                            if (appointment.is_child) {
                                commit("mutateSelectedCustomerType", CHILD);
                                commit(
                                    "mutateSelectedChildId",
                                    appointment.customer_id
                                );
                            } else if (appointment.is_pet) {
                                commit("mutateSelectedCustomerType", PET);
                                commit(
                                    "mutateSelectedPetId",
                                    appointment.customer_id
                                );
                            } else {
                                commit("mutateSelectedCustomerType", MYSELF);
                                commit(
                                    "mutateSelectedCustomerId",
                                    appointment.customer_id
                                );
                            }
                            dispatch("getEmployeeSchedule");
                        })
                        .finally(() => {
                            commit("mutateLoadingGeneral", false);
                        });
                    resolve(res);
                })
                .catch((error) => {
                    commit("mutateLoadingGeneral", false);
                    reject(error);
                });
        });
    },
    signTerms({ }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/appointments/terms/sign`, payload)
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    downloadSignedTerms({ }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/appointments/terms/${id}`, {
                    responseType: "blob",
                })
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                        "download",
                        `signed-document-${new Date()
                            .toJSON()
                            .slice(0, 16)}.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getStatusHistory({ }, appointmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/appointments/${appointmentId}/status/history`)
                .then((res) => {
                    resolve(res.data?.data?.history);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default actions;
